/**
 * Constants for mining zone identifiers that match backend MiningZoneConstants
 */
export const MiningZoneConstants = {
  /**
   * Standard Ore Belt mining zone
   */
  ORE_BELT: 'OreBelt',
  
  /**
   * Ice Belt mining zone with higher yields but longer travel time
   */
  ICE_BELT: 'IceBelt',
  
  /**
   * Lava Belt mining zone with highest yields but highest risk
   */
  LAVA_BELT: 'LavaBelt'
} as const;

// Type for the mining zone identifiers
export type MiningZoneId = typeof MiningZoneConstants[keyof typeof MiningZoneConstants];
